/**
 * The eight fields Adyen requires on a `channel: Web` payment. They feed the
 * 3DS2 device fingerprint sent to the issuer's ACS, so every one of them has to
 * come from the browser — a server-side stand-in would degrade authentication.
 */
export type BrowserInfo = {
  acceptHeader: string;
  colorDepth: number;
  language: string;
  javaEnabled: boolean;
  screenHeight: number;
  screenWidth: number;
  userAgent: string;
  timeZoneOffset: number;
};

export function getBrowserInfo(): BrowserInfo {
  return {
    acceptHeader: 'acceptHeader' in navigator ? (navigator.acceptHeader as string) : '*/*', // Not directly available, use fallback
    colorDepth: screen.colorDepth || window.screen.colorDepth,
    language: navigator.language,
    javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
    screenHeight: screen.height || window.screen.height,
    screenWidth: screen.width || window.screen.width,
    userAgent: navigator.userAgent,
    timeZoneOffset: new Date().getTimezoneOffset(),
  };
}
